(function () {
  'use strict';

  if (window.__parallaxReady) return;
  window.__parallaxReady = true;

  var els = [];
  var pending = false;

  function collect() {
    els = Array.from(document.querySelectorAll('[data-parallax]')).map(function (el) {
      return { el: el, speed: parseFloat(el.dataset.parallaxSpeed || '0.2') };
    });
  }

  function tick() {
    var vy = window.innerHeight;
    els.forEach(function (item) {
      var rect = item.el.getBoundingClientRect();
      // skip elements not near the viewport
      if (rect.bottom < -vy || rect.top > vy * 2) return;
      var mid = rect.top + rect.height * 0.5;
      var delta = (vy * 0.5 - mid) * item.speed;
      item.el.style.transform = 'translateY(' + delta.toFixed(1) + 'px) translateZ(0)';
    });
    pending = false;
  }

  function onScroll() {
    if (!pending) {
      pending = true;
      requestAnimationFrame(tick);
    }
  }

  function init() {
    collect();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { collect(); tick(); }, { passive: true });
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
